import React from "react";
import { NavLink } from "react-router-dom";

const images = [
  require("./../../images/gallery/about1.png"),
  require("./../../images/gallery/about2.png"),
];

const stats = [
  { number: "5000+", label: "Happy Clients", icon: "fa fa-users" },
  { number: "150+", label: "Projects Completed", icon: "fa fa-building" },
  { number: "20+", label: "Years Experience", icon: "fa fa-calendar" },
  { number: "99%", label: "Satisfaction Rate", icon: "fa fa-star" },
];

const features = [
  {
    icon: "fa fa-shield-alt",
    title: "Quality Assurance",
    description:
      "Premium materials from trusted brands with guaranteed quality standards",
  },
  {
    icon: "fa fa-shipping-fast",
    title: "Fast Delivery",
    description:
      "Quick and reliable delivery to keep your projects on schedule",
  },
  {
    icon: "fa fa-handshake",
    title: "Trusted Partners",
    description: "Long-standing relationships with industry-leading suppliers",
  },
  {
    icon: "fa fa-headset",
    title: "24/7 Support",
    description:
      "Round-the-clock customer support for all your construction needs",
  },
];

var bnr1 = require("./../../images/background/bg-6.png");

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentImageIndex: 0,
      isVisible: false,
    };
    this.imageInterval = null;
  }

  componentDidMount() {
    this.startImageSlider();
    this.observeSection();
  }

  componentWillUnmount() {
    this.clearImageInterval();
  }

  startImageSlider = () => {
    this.imageInterval = setInterval(() => {
      this.setState(prevState => ({
        currentImageIndex: (prevState.currentImageIndex + 1) % images.length,
      }));
    }, 4000);
  };

  clearImageInterval = () => {
    if (this.imageInterval) {
      clearInterval(this.imageInterval);
      this.imageInterval = null;
    }
  };

  observeSection = () => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.setState({ isVisible: true });
        }
      },
      { threshold: 0.3 }
    );

    if (this.aboutRef) {
      observer.observe(this.aboutRef);
    }
  };
  render() {
    const { currentImageIndex, isVisible } = this.state;

    return (
      <>
        <div
          ref={ref => (this.aboutRef = ref)}
          className="section-full mobile-page-padding p-t80 p-b80"
          style={{
            // background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Animated Background Shapes */}

          <div className="container">
            {/* ENHANCED TITLE START */}
            <div
              className="section-head text-center"
              style={{ marginBottom: "60px" }}
            >
              <h2
                style={{
                  fontSize: "3rem",
                  fontWeight: "700",
                  color: "rgb(51, 51, 51)",
                  marginBottom: "20px",
                  textTransform: "uppercase",
                  letterSpacing: "2px",
                  textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                }}
              >
                About <span style={{ color: "#3fa4ca" }}>Our Company</span>
              </h2>
              <div
                style={{
                  width: "100px",
                  height: "4px",
                  backgroundColor: "#3fa4ca",
                  margin: "0 auto 25px",
                  borderRadius: "2px",
                }}
              />
              <p
                style={{
                  fontSize: "1.2rem",
                  color: "rgba(255, 255, 255, 0.9)",
                  maxWidth: "700px",
                  margin: "0 auto",
                  lineHeight: "1.6",
                  fontWeight: "300",
                }}
              >
                Building the future of construction through innovation, quality,
                and trusted partnerships
              </p>
            </div>
            {/* TITLE END */}

            {/* MAIN CONTENT */}
            <div
              className="row align-items-center"
              style={{ marginBottom: "80px" }}
            >
              {/* Image Section */}
              <div className="col-lg-6 col-md-12 mb-4">
                <div
                  style={{
                    position: "relative",
                    borderRadius: "20px",
                    overflow: "hidden",
                    boxShadow: "0 20px 50px rgba(0,0,0,0.3)",
                    transform: isVisible
                      ? "translateX(0)"
                      : "translateX(-50px)",
                    opacity: isVisible ? 1 : 0,
                    transition: "all 0.8s ease",
                  }}
                >
                  <img
                    src={images[currentImageIndex]}
                    alt={`About image ${currentImageIndex + 1}`}
                    style={{
                      width: "100%",
                      height: "460px",
                      objectFit: "cover",
                      transition: "opacity 0.5s ease",
                    }}
                  />
                  {/* Image overlay */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      background:
                        "linear-gradient(transparent, rgba(0,0,0,0.7))",
                      padding: "30px",
                      color: "white",
                    }}
                  >
                    <h4 style={{ margin: 0, fontSize: "1.2rem" }}>
                      Building Excellence Since 2004
                    </h4>
                  </div>

                  {/* Image indicators */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: "15px",
                      right: "20px",
                      display: "flex",
                      gap: "8px",
                    }}
                  >
                    {images.map((_, index) => (
                      <div
                        key={index}
                        style={{
                          width: "10px",
                          height: "10px",
                          borderRadius: "50%",
                          backgroundColor:
                            currentImageIndex === index
                              ? "#3fa4ca"
                              : "rgba(255,255,255,0.5)",
                          transition: "all 0.3s ease",
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div>

              {/* Content Section */}
              <div className="col-lg-6 col-md-12">
                <div
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    padding: "40px",
                    borderRadius: "20px",
                    boxShadow: "0 15px 35px rgba(0,0,0,0.2)",
                    transform: isVisible ? "translateX(0)" : "translateX(50px)",
                    opacity: isVisible ? 1 : 0,
                    transition: "all 0.8s ease 0.2s",
                  }}
                >
                  <h3
                    style={{
                      fontSize: "2rem",
                      fontWeight: "600",
                      color: "#333",
                      marginBottom: "20px",
                      lineHeight: "1.3",
                    }}
                  >
                    <span style={{ fontWeight: "300", color: "#666" }}>
                      Committed
                    </span>{" "}
                    to Superior Quality, Best Rates and Reliability
                  </h3>

                  <p
                    style={{
                      color: "#555",
                      fontSize: "1rem",
                      lineHeight: "1.7",
                      marginBottom: "25px",
                    }}
                  >
                    <strong>
                      Our mission is to build the most trusted B2B e-commerce
                      platform that helps SMEs unlock their potential by
                      transforming the way they do their business.
                    </strong>
                  </p>

                  <p
                    style={{
                      color: "#666",
                      fontSize: "0.95rem",
                      lineHeight: "1.6",
                      marginBottom: "30px",
                    }}
                  >
                    The platform provides a transparent and reliable marketplace
                    where businesses can source raw materials at competitive
                    prices, reducing costs and simplifying procurement
                    operations. Build infra emphasizes affordability, speed, and
                    scalability, positioning itself as India’s go-to solution
                    for solving sourcing challenges in the construction
                    ecosystem it is building one of India’s largest networks for
                    raw material procurement
                  </p>

                  <div style={{ marginBottom: "30px" }}>
                    <div className="row">
                      <div className="col-6 mb-3">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <i
                            className="fa fa-check-circle"
                            style={{
                              color: "#3fa4ca",
                              fontSize: "1.2rem",
                              marginRight: "10px",
                            }}
                          />
                          <span style={{ color: "#555", fontSize: "0.9rem" }}>
                            Premium Quality
                          </span>
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <i
                            className="fa fa-check-circle"
                            style={{
                              color: "#3fa4ca",
                              fontSize: "1.2rem",
                              marginRight: "10px",
                            }}
                          />
                          <span style={{ color: "#555", fontSize: "0.9rem" }}>
                            Trusted Brands
                          </span>
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <i
                            className="fa fa-check-circle"
                            style={{
                              color: "#3fa4ca",
                              fontSize: "1.2rem",
                              marginRight: "10px",
                            }}
                          />
                          <span style={{ color: "#555", fontSize: "0.9rem" }}>
                            Fast Delivery
                          </span>
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <i
                            className="fa fa-check-circle"
                            style={{
                              color: "#3fa4ca",
                              fontSize: "1.2rem",
                              marginRight: "10px",
                            }}
                          />
                          <span style={{ color: "#555", fontSize: "0.9rem" }}>
                            24/7 Support
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <NavLink
                    to="/about"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      padding: "15px 30px",
                      backgroundColor: "#3fa4ca",
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "50px",
                      fontSize: "1rem",
                      fontWeight: "600",
                      transition: "all 0.3s ease",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                    onMouseOver={e => {
                      e.target.style.backgroundColor = "#339bb5";
                      e.target.style.transform = "translateY(-3px)";
                      e.target.style.boxShadow =
                        "0 10px 25px rgba(63, 164, 202, 0.3)";
                    }}
                    onMouseOut={e => {
                      e.target.style.backgroundColor = "#3fa4ca";
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    Learn More About Us
                    <i
                      className="fa fa-arrow-right"
                      style={{ marginLeft: "10px" }}
                    />
                  </NavLink>
                </div>
              </div>
            </div>

            {/* STATISTICS SECTION */}
            {/* <div className="row text-center" style={{ marginBottom: "60px" }}>
              {stats.map((stat, index) => (
                <div key={index} className="col-lg-3 col-md-6 col-sm-6 mb-4">
                  <div
                    style={{
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                      padding: "40px 20px",
                      borderRadius: "15px",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      backdropFilter: "blur(10px)",
                      transition: "all 0.3s ease",
                      transform: isVisible
                        ? "translateY(0)"
                        : "translateY(30px)",
                      opacity: isVisible ? 1 : 0,
                      transitionDelay: `${index * 0.1}s`,
                    }}
                    onMouseOver={e => {
                      e.currentTarget.style.transform = "translateY(-10px)";
                      e.currentTarget.style.backgroundColor =
                        "rgba(255, 255, 255, 0.15)";
                    }}
                    onMouseOut={e => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.backgroundColor =
                        "rgba(255, 255, 255, 0.1)";
                    }}
                  >
                    <i
                      className={stat.icon}
                      style={{
                        fontSize: "3rem",
                        color: "#3fa4ca",
                        marginBottom: "15px",
                        filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.3))",
                      }}
                    />
                    <h3
                      style={{
                        fontSize: "2.5rem",
                        fontWeight: "700",
                        color: "white",
                        margin: "10px 0 5px",
                        textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                      }}
                    >
                      {stat.number}
                    </h3>
                    <p
                      style={{
                        color: "rgba(255, 255, 255, 0.9)",
                        margin: 0,
                        fontSize: "1rem",
                        fontWeight: "500",
                      }}
                    >
                      {stat.label}
                    </p>
                  </div>
                </div>
              ))}
            </div> */}

            {/* FEATURES SECTION */}
            {/* <div className="row">
              {features.map((feature, index) => (
                <div key={index} className="col-lg-3 col-md-6 col-sm-6 mb-4">
                  <div
                    style={{
                      backgroundColor: "white",
                      padding: "30px 20px",
                      borderRadius: "15px",
                      textAlign: "center",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                      transition: "all 0.3s ease",
                      height: "100%",
                      transform: isVisible ? "scale(1)" : "scale(0.9)",
                      opacity: isVisible ? 1 : 0,
                      transitionDelay: `${0.5 + index * 0.1}s`,
                    }}
                    onMouseOver={e => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow =
                        "0 20px 40px rgba(0,0,0,0.15)";
                    }}
                    onMouseOut={e => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 30px rgba(0,0,0,0.1)";
                    }}
                  >
                    <div
                      style={{
                        width: "70px",
                        height: "70px",
                        backgroundColor: "rgba(63, 164, 202, 0.1)",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 20px",
                      }}
                    >
                      <i
                        className={feature.icon}
                        style={{
                          fontSize: "1.8rem",
                          color: "#3fa4ca",
                        }}
                      />
                    </div>
                    <h4
                      style={{
                        fontSize: "1.2rem",
                        fontWeight: "600",
                        color: "#333",
                        marginBottom: "15px",
                      }}
                    >
                      {feature.title}
                    </h4>
                    <p
                      style={{
                        color: "#666",
                        fontSize: "0.9rem",
                        lineHeight: "1.6",
                        margin: 0,
                      }}
                    >
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div> */}
          </div>
        </div>

        {/* CSS Animations */}
        <style jsx>{`
                    @keyframes float {
                        0%, 100% { transform: translateY(0px); }
                        50% { transform: translateY(-20px); }
                    }
                `}</style>
      </>
    );
  }
}

export default About;
